// +----------------------------------------------------------------------
// | 接口地址配置（两级优先）
// |
// | 1. 运行时：public/config.js 的 window.APP_CONFIG.apiOrigin（优先级最高，
// |    构建后就是 dist/config.js，部署后可直接改，刷新即生效，无需重新构建）
// | 2. 构建默认：webpack DefinePlugin 注入的 __API_ORIGIN__
// |    （dev 默认 '' 走同域 /api 代理，prod 默认线上 API 域名，见 webpack.config.js）
// |
// | 本地直连线上联调仍可用：
// |     npm run dev --env api=https://api.xiangxiang.sxswyc.top
// +----------------------------------------------------------------------

/* global __API_ORIGIN__ */
const BUILD_DEFAULT = typeof __API_ORIGIN__ === 'string' ? __API_ORIGIN__ : '';

const runtime = (typeof window !== 'undefined' && window.APP_CONFIG) || {};
// 显式区分「没写」和「写了空串」：写了 '' 表示强制走同域相对路径 /api
const hasRuntimeOrigin = typeof runtime.apiOrigin === 'string';

const ORIGIN = hasRuntimeOrigin
  ? runtime.apiOrigin.replace(/\/+$/, '')
  : BUILD_DEFAULT;

/** axios 的 baseURL：形如 'https://api.xiangxiang.sxswyc.top/api' 或 '/api' */
export const API_BASE = `${ORIGIN}/api`;

export default API_BASE;
